import { AuthActionTypes, AuthActions, ScreenTransition } from './types'
import type { IToast } from '@components/molecules/toast'
import type { AuthScreen } from '../'


export const setToast = (toast: IToast): AuthActionTypes => ({
    type: AuthActions.SET_TOAST,
    payload: toast
})

export const setScreen = (screen: AuthScreen): AuthActionTypes => ({
    type: AuthActions.SET_SCREEN,
    payload: screen
})
export const setTransitionState = (state: ScreenTransition): AuthActionTypes => ({
    type: AuthActions.SET_TRANSITION_STATE,
    payload: state
})
export const setIsNewUser = (isNewUser: boolean): AuthActionTypes => ({
    type: AuthActions.SET_IS_NEW_USER,
    payload: isNewUser
})


export const authStateReset = (): AuthActionTypes => ({
    type: AuthActions.RESET
})
